// ** Modules
import { type getProviders, signIn } from 'next-auth/react';

// ** UI
import Grid from '@mui/material/Grid';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

// ** Icons
import PersonIcon from '@mui/icons-material/Person';

// ** Components
import { Icon } from '@/components/common/icons';

// ** Types
import type React from 'react';
import type { SxProps, Theme } from '@mui/material/styles';

type ProvidersMap = Awaited<ReturnType<typeof getProviders>>;

export type HeaderLoginSignUpProps = {
	providers?: ProvidersMap | null;
};

const HeaderLoginSignUp: React.FC<HeaderLoginSignUpProps> = ({ providers }) => {
	// Media Queries
	const isMobile = useMediaQuery((theme: Theme) => theme?.breakpoints.down('sm'));

	const theme = useTheme();

	const iconCss: SxProps<Theme> = {
		height: 36,
		width: 36,
		display: 'block',
		transition: 'color 0.3s ease',
		color: theme.palette.primary.main,
		'&:hover': {
			cursor: 'pointer',
			color: `${theme.palette.secondary.main} !important`
		}
	};

	const handleSignIn = () => {
		let providerId: string | null = null;

		if (Array.isArray(providers)) {
			providerId = (providers[0] as { id?: string })?.id || null;
		} else if (typeof providers === 'object' && providers !== null) {
			const providerKeys = Object.keys(providers);

			if (providerKeys.length > 0) {
				providerId = providerKeys[0];
			}
		}

		if (providerId) {
			signIn(providerId);
		}
	};

	return (
		<Grid
			container
			direction="row"
			spacing={{ xs: 4, xl: 10 }}
			sx={{
				alignItems: 'center',
				justifyContent: 'flex-end',
				minWidth: { xs: 226, xl: 'unset' },
				wrap: { xl: 'nowrap' }
			}}
		>
			<Grid>
				{isMobile ? (
					<PersonIcon onClick={handleSignIn} sx={iconCss} />
				) : (
					<Icon name="mdi-account-circle" onClick={handleSignIn} sx={iconCss} />
				)}
			</Grid>
		</Grid>
	);
};

export default HeaderLoginSignUp;
